import axios from "axios";

export const executeCode = async (code, language) => {
  fetch("https://api.paiza.io/runners/create", {
    method: "POST",
    mode: "no-cors",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      source_code: "console.log('My name is mpankaj');",
      language: "javascript",
      api_key: "guest",
    }),
  })
    .then((response) => response.json())
    .then((data) => console.log(data))
    .catch((error) => console.error("Fetch Error:", error));

  try {
    const response = await axios.post("https://api.paiza.io/runners/create", {
      source_code: code,
      language,
      api_key: "guest", // Free API Key
    });

    const { id } = response.data;

    // Wait for the code execution result
    const result = await new Promise(
      (resolve) =>
        setTimeout(async () => {
          const res = await axios.get(
            `https://api.paiza.io/runners/get_details?id=${id}&api_key=guest`
          );
          resolve(res.data);
        }, 3000) // Wait 3 seconds before fetching result
    );

    return result.stdout || result.stderr || "No output";
  } catch (error) {
    console.error("Error:", error);
    return "Error executing code";
  }
};
